import { render, staticRenderFns } from "./DialogNewContentTopic.vue?vue&type=template&id=3b1feb78&scoped=true"
import script from "./DialogNewContentTopic.vue?vue&type=script&lang=js"
export * from "./DialogNewContentTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1feb78",
  null
  
)

export default component.exports